import { FormEvent, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Brand } from '../components/Brand';
import { demoMode, supabase } from '../lib/supabase';

export function Login() {
  const [params] = useSearchParams();
  const requestedNext = params.get('next') || '/';
  const next = requestedNext.startsWith('/') && !requestedNext.startsWith('//') && !requestedNext.includes('\\') ? requestedNext : '/';
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (demoMode) {
      window.location.href = next;
      return;
    }
    if (!supabase) {
      setError('Secure sign-in is not configured. Please contact ROAM.');
      return;
    }
    setError('');
    const redirectTo = `${window.location.origin}${next}`;
    const { error } = await supabase.auth.signInWithOtp({ email, options: { emailRedirectTo: redirectTo } });
    if (error) setError(error.message);
    else setSent(true);
  }

  return (
    <main className="gate-page">
      <nav className="topbar"><Brand small /><Link to="/">ROAM</Link></nav>
      <section className="login-card">
        <div className="eyebrow">PRIVATE MEDIA ACCESS</div>
        <h1>{sent ? 'Check your email.' : 'Welcome back.'}</h1>
        {sent ? <p>We sent a secure sign-in link to <strong>{email}</strong>. No password needed.</p> : (
          <form onSubmit={submit}>
            <p>Enter the email address your ROAM invitation was sent to.</p>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
            {error && <p className="error">{error}</p>}
            <button className="button button--light button--wide">Email me a secure link</button>
          </form>
        )}
      </section>
    </main>
  );
}
